import {createSelector} from 'reselect'
import {getPanelSelectedYear, isShownHolidayList} from '../holidayList/selectors'
import {geSelectedYear} from '../../../selectors'

export const getImportHolidaysPanelState = state => state.workSchedule.importHolidaysPanel

export const isShownImportHolidaysPanel = createSelector(
    getImportHolidaysPanelState,
    (importHolidaysPanel) => importHolidaysPanel.isShown
)

export const isLoadingImportedHolidays = createSelector(
    getImportHolidaysPanelState,
    (importHolidaysPanel) => importHolidaysPanel.loading
)

export const getYear = createSelector(
    isShownHolidayList,
    getPanelSelectedYear,
    geSelectedYear,
    (isShownHolidayList, panelSelectedYear, workScheduleSelectedYear) => isShownHolidayList ? panelSelectedYear : workScheduleSelectedYear
)

export const getCountry = createSelector(
    getImportHolidaysPanelState,
    (importHolidaysPanel) => importHolidaysPanel.country
)

export const getFileName = createSelector(
    getImportHolidaysPanelState,
    (importHolidaysPanel) => importHolidaysPanel.fileName
)

export const getHolidays = createSelector(
    getImportHolidaysPanelState,
    (importHolidaysPanel) => importHolidaysPanel.holidays
)

export const hasHolidaysInPast = createSelector(
    getImportHolidaysPanelState,
    (importHolidaysPanel) => importHolidaysPanel.hasHolidaysInPast
)

export const isImportHolidaysInProcess = createSelector(
    getImportHolidaysPanelState,
    (importHolidaysPanel) => importHolidaysPanel.importProcess
)



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/importHolidays/selectors.js